import { registerFeature } from "lib/features"

export const FEATURE_FLAG_EDIT_ASSETS = registerFeature({
    numericalId: 2.3,
    name: "Edit Assets",
    id: "edit-assets",
    description: "SPECIAL ADMIN USERS ONLY-TO BE CONFIRMED",
    internalUseOnly: true,
})
